import { __assign, __read } from "tslib";
import React, { useMemo, useRef, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { useTheme } from "@material-ui/core/styles";
import { MoreVert } from "@material-ui/icons";
import cn from "classnames";
import { CustomMenuList } from "./styles";
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            display: "flex"
        },
        paper: {
            marginRight: theme.spacing(2)
        },
        menu: {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.background.paper,
            width: "auto",
            height: "auto"
        },
        icon: {
            "&:hover": {
                backgroundColor: "hsla(0,0%,100%,0.08)"
            }
        },
        noPadding: {
            padding: 0
        }
    });
});
export var ActionMenu = function (_a) {
    var _b;
    var noPadding = _a.noPadding, customMenuItems = _a.customMenuItems;
    var classes = useStyles();
    var theme = useTheme();
    var _c = __read(useState(false), 2), open = _c[0], setOpen = _c[1];
    var anchorRef = useRef(null);
    var filteredMenuItems = useMemo(function () { return customMenuItems.filter(function (item) { return item.visible; }); }, [customMenuItems]);
    return (React.createElement("div", { className: classes.root },
        filteredMenuItems.length !== 0 && (React.createElement(IconButton, { ref: anchorRef, "aria-controls": open ? "menu-list-grow" : undefined, "aria-haspopup": "true", onClick: function () { return setOpen(function (p) { return !p; }); }, className: cn(classes.icon, (_b = {},
                _b[classes.noPadding] = noPadding,
                _b)) },
            React.createElement(MoreVert, { style: { fill: theme.palette.colors.basic[1400] } }))),
        React.createElement(Popper, { open: open, anchorEl: anchorRef.current, style: { zIndex: 3 }, role: undefined, transition: true, placement: "bottom-end" }, function (_a) {
            var TransitionProps = _a.TransitionProps;
            return (React.createElement(Grow, __assign({}, TransitionProps),
                React.createElement(Paper, { classes: { root: classes.menu } },
                    React.createElement(ClickAwayListener, { onClickAway: function () { return setOpen(false); } },
                        React.createElement(CustomMenuList, { id: "menu-list-grow" }, filteredMenuItems.map(function (item) { return (React.createElement(MenuItem, { key: item.label, onClick: item.onClick, disabled: item.disabled }, item.label)); }))))));
        })));
};
//# sourceMappingURL=ActionMenu.js.map